
import {  useQuery } from "react-query"
import DataService from '../../../config/DataServices'

const {  getRequest } = DataService()



export const useGetVerifyUser = (enabled) => {
    return useQuery({
        queryKey: ['verify-userAdmin'],
        queryFn: () => {
            return getRequest(`user/auth/verify-user`);
        },
        enabled: enabled, // ✅ control execution
    });
};